import React, { useState, useEffect } from 'react';
import { DollarSign, Filter, RefreshCw } from 'lucide-react';

const PaymentManagement = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    fetchPayments();
  }, [statusFilter]);

  const fetchPayments = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const url = statusFilter
        ? `${process.env.REACT_APP_BACKEND_URL}/api/admin/payments?status=${statusFilter}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/admin/payments`;
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed');
      const data = await response.json();
      setPayments(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const refundPayment = async (paymentId) => {
    if (!confirm('Подтвердите возврат платежа')) return;
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/payments/${paymentId}/refund`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed');
      alert('Платеж возвращен');
      fetchPayments();
    } catch (err) {
      alert('Ошибка: ' + err.message);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      completed: 'bg-green-500/20 text-green-400',
      pending: 'bg-yellow-500/20 text-yellow-400',
      failed: 'bg-red-500/20 text-red-400',
      refunded: 'bg-gray-500/20 text-gray-400'
    };
    const labels = {
      completed: 'Завершен',
      pending: 'В ожидании',
      failed: 'Отклонен',
      refunded: 'Возвращен'
    };
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${badges[status] || badges.pending}`}>
        {labels[status] || status}
      </span>
    );
  };

  return (
    <div>
      <div className="mb-6 flex items-center gap-4">
        <div className="relative flex-1">
          <Filter className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            <option value="">Все платежи</option>
            <option value="completed">Завершенные</option>
            <option value="pending">В ожидании</option>
            <option value="failed">Отклоненные</option>
            <option value="refunded">Возвращенные</option>
          </select>
        </div>
        <button
          onClick={fetchPayments}
          className="p-3 bg-gray-800/50 border border-gray-700 rounded-lg hover:bg-gray-700 transition-colors"
        >
          <RefreshCw className="w-5 h-5 text-gray-400" />
        </button>
      </div>

      <div className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-900/50">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">ID</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Пользователь</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Сумма</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Тип</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Статус</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Дата</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Действия</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {loading ? (
                <tr><td colSpan="7" className="px-6 py-8 text-center text-gray-400">Загрузка...</td></tr>
              ) : payments.length === 0 ? (
                <tr><td colSpan="7" className="px-6 py-8 text-center text-gray-400">Платежи не найдены</td></tr>
              ) : (
                payments.map((payment) => (
                  <tr key={payment.id} className="hover:bg-gray-900/30 transition-colors">
                    <td className="px-6 py-4 text-gray-400 text-sm font-mono">{payment.id.substring(0, 8)}...</td>
                    <td className="px-6 py-4">
                      <div className="text-white font-medium">{payment.user_email}</div>
                    </td>
                    <td className="px-6 py-4 text-white font-bold">{payment.amount.toFixed(0)} ₽</td>
                    <td className="px-6 py-4 text-gray-300 text-sm">{payment.plan_type}</td>
                    <td className="px-6 py-4">{getStatusBadge(payment.status)}</td>
                    <td className="px-6 py-4 text-gray-400 text-sm">
                      {new Date(payment.created_at).toLocaleDateString('ru-RU')}
                    </td>
                    <td className="px-6 py-4">
                      {payment.status === 'completed' && (
                        <button
                          onClick={() => refundPayment(payment.id)}
                          className="px-3 py-1 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg text-sm transition-colors"
                        >
                          Вернуть
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PaymentManagement;